var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1235 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 650,
    fill: "#b22234"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 50,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 50,
    y: 150
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 50,
    y: 250
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 50,
    y: 350
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 50,
    y: 450
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 50,
    y: 550
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 350,
    fill: "#3c3b6e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 20,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 55,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 55,
    r: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.4b8c8773833570b675959ccc9ceb6866.svg";
export { ForwardRef as ReactComponent };